import { ICategoryDto } from "@/Domain/Dtos/Food/categoryDto";
import { IInfoDto } from "@/Domain/Dtos/menu/menuDto";
import { singleton } from "tsyringe";
import BaseService from "../Base/BaseService";
import { UserErrorMessage } from "../Base/ErrorMessages/UserErrorMessages";

@singleton()
export class FoodService extends BaseService {

    constructor() {
        super(new UserErrorMessage());
    }

    async getInfo(): Promise<IInfoDto> {
        try {
            const result = await this.repositoryWrapper.Food.getInfo()
            return result;
        } catch (e) {
            throw e
        }
    }

    async getMenu(): Promise<ICategoryDto[]> {
        try {
            const result = await this.repositoryWrapper.Food.getMenu()
            return result.menu;
        } catch (e) {
            throw e
        }
    }


}